import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MiniAppssComponent} from './miniapps.component';
import {LaunchMiniAppsComponent} from './launch-miniapps/launch-miniapps.component';
import { MiniAppssListComponent} from './miniapps-list/miniapps-list.component';
import { EditMiniAppsComponent } from './edit-miniapps/edit-miniapps.component';
import { AuthGuard } from '../guards/auth.guard';

const routes: Routes = [
  {
    path: '',
    component: MiniAppssListComponent,
  },
  {
    path: 'create-miniapps',
    component: MiniAppssComponent,
  },
  {
    path: 'create-miniapps/:id/:stepNumber',
    component: MiniAppssComponent,
  },
  {
    path: 'launch/:id',
    component: LaunchMiniAppsComponent,
  },
  {
    path: 'edit/:id',
    component: EditMiniAppsComponent,
  }
  
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MiniAppssRoutingModule {}
